import { render, staticRenderFns } from "./status.vue?vue&type=template&id=4882500a&scoped=true&"
import script from "./status.vue?vue&type=script&lang=ts&"
export * from "./status.vue?vue&type=script&lang=ts&"
import style0 from "./status.vue?vue&type=style&index=0&id=4882500a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882500a",
  null
  
)

export default component.exports